/**
 * Séquence 4 — Formation à la conduite sur voies ouvertes (3 h min)
 *
 * C'est LA partie centrale de la formation pratique.
 * Le référentiel demande de travailler systématiquement :
 * prise d'information · communication · partage de la route · perception
 * et prise en compte des risques.
 *
 * Puis détaille 10 compétences.
 */
export const sequence4 = {
  officiel: {
    exigencesTransversales: [
      { key: 'prise-info',   label: "Prise d'information",         icon: 'Eye' },
      { key: 'communication', label: 'Communication',              icon: 'MessageCircle' },
      { key: 'partage',      label: 'Partage de la route',         icon: 'Users' },
      { key: 'risques',      label: 'Perception & prise en compte des risques', icon: 'AlertTriangle' },
    ],
    competences: [
      {
        num: 1, id: 'demarrer', label: 'Démarrer',
        items: [
          'Démarrer hors circulation',
          'Démarrer alors que je suis déjà dans la circulation',
          "M'insérer en sécurité",
          'Prendre en compte la vitesse des autres véhicules',
          "M'assurer d'être correctement vu",
        ],
        enjeu: 'La voiturette est plus lente que le trafic : chaque insertion est un temps critique.',
      },
      {
        num: 2, id: 'ralentir-arreter', label: 'Ralentir et s’arrêter',
        items: ['Freinage', 'Arrêt', 'Départ', 'Feux', 'STOP', 'Ralentissement', 'Sortie de circulation'],
      },
      {
        num: 3, id: 'stationner', label: "S'arrêter et stationner",
        items: [
          "Avant l'arrêt : rechercher la signalisation · les indices utiles",
          'Prendre les informations · communiquer ses intentions · adapter son allure',
          "Pour repartir : prendre les infos · communiquer · s'insérer · adapter son allure",
        ],
        specifiqueVoiturette: [
          'Stationnement en épi',
          'Stationnement en bataille',
          'Stationnement en créneau',
        ],
      },
      {
        num: 4, id: 'rechercher-indices', label: 'Rechercher les indices',
        items: [
          'Signalisation',
          'Clignotants des autres véhicules',
          'Trajectoire des autres',
          "Regard des autres usagers",
          'Adapter son comportement en conséquence',
        ],
      },
      {
        num: 5, id: 'allure', label: 'Adapter son allure',
        items: [
          'Adapter la vitesse à ses capacités',
          'Aux possibilités du véhicule',
          'À la signalisation · à la réglementation',
          'Aux autres usagers',
          'À la configuration des lieux · à la visibilité',
        ],
      },
      {
        num: 6, id: 'distances', label: 'Distances',
        items: [
          'Apprécier les distances',
          'Maintenir les distances longitudinales (avant/arrière)',
          'Maintenir les distances latérales',
          'En toutes circonstances',
        ],
      },
      {
        num: 7, id: 'virages', label: 'Virages',
        items: [
          'Négocier un virage',
          'Adopter une trajectoire sécurisée',
          'Regard · vitesse d’approche · trajectoire · visibilité · anticipation · sortie',
        ],
      },
      {
        num: 8, id: 'positionnement', label: 'Positionnement',
        items: [
          'En ligne droite',
          'En virage',
          'En croisement',
          'En dépassement',
          'Tenir compte de : signalisation verticale · marquage au sol · voies réservées',
          'Attention aux angles morts des véhicules lourds',
        ],
      },
      {
        num: 9, id: 'intersections', label: 'Intersections',
        items: [
          "Détecter l'intersection",
          'Identifier son type',
          'Evaluer la visibilité',
          'Adapter son allure',
          'Respecter les règles de priorité',
          "S'arrêter si nécessaire",
          "Repartir et dégager l'intersection",
        ],
      },
      {
        num: 10, id: 'changement-direction', label: 'Changement de direction',
        items: [
          'Avertir',
          'Se positionner',
          'Prendre en compte les autres véhicules (surtout lourds)',
          'Adapter son allure',
          'Respecter les priorités',
          "Dégager l'intersection",
        ],
      },
    ],
  },
  enrichi: {
    activite: {
      titre: 'Que vois-tu ?',
      description:
        "Sur chaque situation (photo/vidéo), on te pose 4 questions dans cet ordre. C'est l'entraînement mental numéro 1 des jeunes conducteurs.",
      questions: [
        { emoji: '👁️', txt: "Qu'est-ce que tu observes ?" },
        { emoji: '⚠️', txt: 'Quel est le danger potentiel ?' },
        { emoji: '🧠', txt: "Que prévois-tu ?" },
        { emoji: '🚗', txt: 'Que vas-tu faire ?' },
      ],
    },
    focusVoiturette: [
      "Les autres véhicules te doubleront souvent : anticipe, garde ta ligne, et NE ralentis JAMAIS brutalement pour « faire de la place ».",
      "Ta vitesse plafonnée à 45 km/h ne te dispense pas des distances de sécurité — elles s'appliquent même en ville.",
      "Lors des manœuvres de stationnement, sers-toi des mesures réduites de ta voiturette : épi et créneau deviennent très accessibles.",
    ],
  },
};

export default sequence4;
